export const emailTypes = {
  ADD_EMAIL: "ADD_EMAIL",
  CLEAR_EMAIL: "CLEAR_EMAIL",
};
